<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("ventasDeProductosGlobal")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>
                        

                        <div class="col-12 col-md-2">
                            <label class="d-none d-md-block" style="margin-bottom: 7px;">&nbsp;</label>
                            <div class="form-group clase-boton-consulta mt-3 mt-md-0" style="margin-bottom: 5px;">
                                <button class="btn btn-primary btn-block-mobile" 
                                        :disabled="loading" 
                                        @click="getSalesProducts()"
                                        :style="loading ? 'background-color: #6c757d !important; border-color: #6c757d !important; color: #ffffff !important; opacity: 1 !important; display: flex; align-items: center; justify-content: center; height: 40px; gap: 10px;' : 'display: flex; align-items: center; justify-content: center; height: 40px; gap: 10px;'">
                                    <i v-if="loading" class="fa fa-refresh fa-spin" style="color: #ffffff !important;"></i>
                                    <i v-else class="fa fa-search"></i>
                                    <span>{{ loading ? 'Consultando...' : $t("consultar") }}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            
            <div class="col-12" v-else>
                <div class="row">
                    
                    <div class="col-12 col-md-8 order-2 order-md-1">
                        
                        <template v-if="list.length > 0 && !loading">

                            <div class="d-none d-md-flex row justify-content-between align-items-center div-export mb-3">
    
                                <div class="col-md-8 d-flex align-items-center text-left">
                                    <el-dropdown class="mr-4">
                                        <el-button type="primary" size="small">
                                            <i class="fa fa-file"></i>
                                            {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <a :href="urlExportPDF"><el-dropdown-item class="text-danger"><strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong></el-dropdown-item></a>
                                            <a :href="urlExportExcel"><el-dropdown-item class="text-success"><strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong></el-dropdown-item></a>
                                            <div class="dropdown-divider"></div>
                                            <a :href="urlExportPDFGlobal"><el-dropdown-item class="text-danger"><strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}} (Vista Global)</strong></el-dropdown-item></a>
                                            <a :href="urlExportExcelGlobal"><el-dropdown-item class="text-success"><strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}} (Vista Global)</strong></el-dropdown-item></a>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    
                                    <div class="custom-control custom-checkbox mb-0">
                                        <input type="checkbox" class="custom-control-input" id="checkNoAgrupar" v-model="noAgrupar" @change="handleCambioAgrupacion">
                                        <label class="custom-control-label text-muted" for="checkNoAgrupar" style="padding-top: 2px; cursor: pointer;">
                                            Ver lista global unida
                                        </label>
                                    </div>
                                </div>
                                
                                <div class="col-md-4 text-right">
                                    <button @click="toggleTodos" 
                                            class="btn btn-outline-primary btn-sm" 
                                            style="min-width: 145px;" 
                                            :style="cargandoTodos || noAgrupar ? 'background-color: #e9ecef !important; border-color: #ced4da !important; color: #6c757d !important; opacity: 1 !important;' : ''" 
                                            :disabled="cargandoTodos || noAgrupar">
                                        <i v-if="cargandoTodos" class="fa fa-spinner fa-spin ml-1" :style="cargandoTodos || noAgrupar ? 'color: #6c757d !important;' : 'color: #007bff !important;'"></i>
                                        <span v-else>
                                            {{ todosAbiertos ? 'Ocultar Todos' : 'Mostrar Todos' }}
                                            <i class="fa ml-2" :class="todosAbiertos ? 'fa-angle-double-up' : 'fa-angle-double-down'"></i>
                                        </span>
                                        <span v-if="cargandoTodos" class="ml-1">Cargando...</span>
                                    </button>
                                </div>
                            </div>

                            <div class="card" v-if="noAgrupar">
                                <div class="card-body p-0">
                                    
                                    <div v-if="cargandoTodos" class="p-5 text-center text-muted">
                                        <i class="fa fa-spinner fa-spin fa-3x mb-3" style="color: #3498db;"></i>
                                        <h5>Procesando vista global...</h5>
                                        <p class="mb-0" style="font-size: 0.9em;">Obteniendo y unificando los productos de todos los negocios.</p>
                                    </div>

                                    <div v-else class="table-responsive">
                                        <table class="table table-striped text-nowrap mb-0">
                                            <thead class="thead-dark">
                                                <tr>
                                                    <th @click="sortGlobal('name')" style="cursor: pointer;">
                                                        <i class="fa" :class="getGlobalSortIcon('name')" style="color: white;"></i> {{$t("producto")}}
                                                    </th>
                                                    <th class="text-center" @click="sortGlobal('cantidad')" style="cursor: pointer;">
                                                        <i class="fa" :class="getGlobalSortIcon('cantidad')" style="color: white;"></i> {{$t("uds")}}
                                                    </th>
                                                    <th class="text-center" @click="sortGlobal('importe')" style="cursor: pointer;">
                                                        <i class="fa" :class="getGlobalSortIcon('importe')" style="color: white;"></i> {{$t("importe")}}
                                                    </th>
                                                    <th class="text-center" @click="sortGlobal('precioMedio')" style="cursor: pointer;">
                                                        <i class="fa" :class="getGlobalSortIcon('precioMedio')" style="color: white;"></i> {{$t("precioMed")}}
                                                    </th>
                                                    <th class="text-center" @click="sortGlobal('porcentaje')" style="cursor: pointer;">
                                                        <i class="fa" :class="getGlobalSortIcon('porcentaje')" style="color: white;"></i> % Total
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="prod in listaGlobalAplanada" :key="prod.name">
                                                    <td>{{ prod.name }}</td>
                                                    <td class="text-center">{{ prod.cantidad }}</td>
                                                    <td class="text-center">{{ prod.importe | currency }}</td>
                                                    <td class="text-center">{{ (prod.importe / prod.cantidad) | currency }}</td>
                                                    <td class="text-center">{{ getPorcentajeGlobal(prod.importe) }} %</td>
                                                </tr>
                                            </tbody>
                                            <tfoot v-if="listaGlobalAplanada.length > 0">
                                                <tr class="table-success">
                                                    <td colspan="2"><strong>TOTAL GLOBAL</strong></td>
                                                    <td class="text-center"><strong>{{ totalGlobalImporte | currency }}</strong></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>

                                </div>
                            </div>

                            <div v-else v-for="(negocio, index) in list" :key="negocio.idBusiness" class="card mb-2 mb-md-3" style="width: 100%;">                                <div class="card-header d-flex justify-content-between align-items-center" style="cursor: pointer; background-color: #ffffff; border-bottom: 2px solid #3498db; padding: 8px 15px;" @click="toggleNegocio(index)">
                                    <h4 style="color: #34495e; margin: 0; display: flex; align-items: center; line-height: 1;">
                                        <i class="fa fa-building text-primary" style="margin-right: 8px;"></i> 
                                        {{ negocio.businessName }}
                                        <i v-if="negocio.isLoading" class="fa fa-spinner fa-spin ml-2 text-warning"></i>
                                    </h4>
                                    <div style="font-size: 1rem; display: flex; align-items: center; line-height: 1;">
                                        <i class="fa" :class="negocio.isOpen ? 'fa-chevron-up text-secondary' : 'fa-chevron-down text-primary'" style="transition: color 0.3s ease;"></i>
                                    </div>
                                </div>

                                <div class="desglose-wrapper" :class="{ 'is-open': negocio.isOpen }">
                                    <div class="desglose-inner">
                                        <div class="card-body p-0">
                                            <div class="table-responsive">
                                                <table class="table table-striped text-nowrap mb-0">
                                                    <thead class="thead-dark">
                                                        <tr>
                                                            <th @click="sortLocal('name')" style="cursor: pointer;">
                                                                <i class="fa" :class="getLocalSortIcon('name')" style="color: white;"></i> {{$t("producto")}}
                                                            </th>
                                                            <th @click="sortLocal('cantidad')" style="cursor: pointer;">
                                                                <i class="fa" :class="getLocalSortIcon('cantidad')" style="color: white;"></i> {{$t("uds")}}
                                                            </th>
                                                            <th class="text-center" @click="sortLocal('importe')" style="cursor: pointer;">
                                                                <i class="fa" :class="getLocalSortIcon('importe')" style="color: white;"></i> {{$t("importe")}}
                                                            </th>
                                                            <th class="text-center" @click="sortLocal('precioMedio')" style="cursor: pointer;">
                                                                <i class="fa" :class="getLocalSortIcon('precioMedio')" style="color: white;"></i> {{$t("precioMed")}}
                                                            </th>
                                                            <th class="text-center" @click="sortLocal('porcentaje')" style="cursor: pointer;">
                                                                <i class="fa" :class="getLocalSortIcon('porcentaje')" style="color: white;"></i> {{$t("porcentajeRespectoTotal")}}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="obj in negocio.products" :key="obj.name">
                                                        <td>{{obj.name}}</td>
                                                        <td>
                                                            <span v-if="obj.pedirPeso" class="text-primary">{{obj.cantidad}} Kg.</span>
                                                            <span v-else>{{obj.cantidad}}</span>
                                                        </td>
                                                        <td class="text-center">{{obj.importe | currency}}</td>
                                                        <td class="text-center">{{(obj.importe /obj.cantidad) | currency}}</td>
                                                        <td class="text-center">{{ getPorcentajeLocal(obj.importe, negocio.products) }} %</td>
                                                    </tr>
                                                    </tbody>
                                                    <tfoot>
                                                    <tr class="table-success">
                                                        <td><strong>{{$t("total")}} {{ negocio.businessName }}</strong></td>
                                                        <td></td>
                                                        <td class="text-center"><strong>{{ getTotalPorNegocio(negocio.products) | currency }}</strong></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </template>
                        <template v-else>
                            <div class="card">
                                <div class="card-body">
                                    <div v-if="loading" class="alert alert-warning mb-0">
                                        <i class="fa fa-spinner fa-spin"></i> {{ $t("cargandoDatos") }}...
                                    </div>
                                    <div v-else-if="!searchPerformed" class="alert mb-0" style="background: linear-gradient(135deg, #34495e 0%, #2c3e50 100%); color: #ecf0f1;">
                                        Haga clic en el botón Consultar para realizar la búsqueda.
                                    </div>
                                    <div v-else class="alert alert-danger mb-0" role="alert">
                                        {{$t("noHayVentasDeProductosEnEsteRangoDeFechas")}}
                                    </div>
                                </div>
                            </div>
                        </template>

                    </div>

                    <div class="col-12 col-md-4 order-1 order-md-2 mb-0" v-show="list.length > 0 && respuesta && permiso">
    
                        <div class="d-block d-md-none mb-3">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <el-dropdown>
                                    <el-button type="primary" size="small">
                                        <i class="fa fa-file"></i>
                                        {{$t("exportar")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <a :href="urlExportPDF"><el-dropdown-item class="text-danger"><strong><i class="fa fa-file-pdf"></i> PDF</strong></el-dropdown-item></a>
                                        <a :href="urlExportExcel"><el-dropdown-item class="text-success"><strong><i class="fa fa-file-excel"></i> Excel</strong></el-dropdown-item></a>
                                        <div class="dropdown-divider"></div>
                                        <a :href="urlExportPDFGlobal"><el-dropdown-item class="text-danger"><strong><i class="fa fa-file-pdf"></i> PDF (Global)</strong></el-dropdown-item></a>
                                        <a :href="urlExportExcelGlobal"><el-dropdown-item class="text-success"><strong><i class="fa fa-file-excel"></i> Excel (Global)</strong></el-dropdown-item></a>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                
                                <div class="custom-control custom-checkbox mb-0 text-right">
                                    <input type="checkbox" class="custom-control-input" id="checkNoAgruparMovil" v-model="noAgrupar" @change="handleCambioAgrupacion">
                                    <label class="custom-control-label text-muted" for="checkNoAgruparMovil" style="padding-top: 2px; cursor: pointer; font-size: 0.85rem;">
                                        Ver lista global
                                    </label>
                                </div>
                            </div>

                            <button @click="toggleTodos" 
                                    class="btn btn-outline-primary btn-sm w-100" 
                                    style="padding: 8px; font-size: 0.9rem;" 
                                    :style="cargandoTodos || noAgrupar ? 'background-color: #e9ecef !important; border-color: #ced4da !important; color: #6c757d !important; opacity: 1 !important;' : ''" 
                                    :disabled="cargandoTodos || noAgrupar">
                                <i v-if="cargandoTodos" class="fa fa-spinner fa-spin ml-1" :style="cargandoTodos || noAgrupar ? 'color: #6c757d !important;' : 'color: #007bff !important;'"></i>
                                <span v-else>
                                    {{ todosAbiertos ? 'Ocultar Todos' : 'Mostrar Todos' }}
                                </span>
                                <span v-if="cargandoTodos" class="ml-1">...</span>
                            </button>
                        </div>
                        
                        <div class="card mb-2 mb-md-3">
                            <div class="card-body text-center">
                                <div v-if="!hayNegociosEnTarta" class="p-3 text-muted">
                                    <i class="fa fa-pie-chart fa-3x mb-3" style="opacity: 0.3"></i>
                                    <h5>Construye tu gráfica</h5>
                                    <p style="font-size: 0.9em; margin-bottom: 0;">Abre las ventanas de los negocios para comparar sus ventas aquí.</p>
                                </div>
                                <div v-else>
                                    <div class="btn-group d-flex mb-3" role="group">
                                        <button @click="chartIn = 0; initChart()" class="btn w-100" :class="chartIn === 0 ? 'btn-primary' : 'btn-outline-primary'">
                                            {{$t("porUnidades")}}
                                        </button>
                                        <button @click="chartIn = 1; initChart()" class="btn w-100" :class="chartIn === 1 ? 'btn-primary' : 'btn-outline-primary'">
                                            {{$t("porImporte")}}
                                        </button>
                                    </div>
                                    <div class="chart-container" style="height:300px; width: 100%;">
                                        <canvas id="chart"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.$store.dispatch("setNameRoute", this.$i18n.t('ventasDeProductosGlobal'));
            
            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                
                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
                
            }
            
            // this.loading = true;
            // this.getSalesProducts(); // MU PELIGROSO, NO PONER PLS
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                localSortCol: 'importe',
                localSortOrder: 'desc',
                globalSortCol: 'importe',
                globalSortOrder: 'desc',
                noAgrupar: false,
                cargandoTodos: false,
                loading: false,
                searchPerformed: false,
                statusConsulta: 'idle',
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                listBusinesses: [],
                listCasas: [],
                idBusiness: 0,
                idCasa: 0,
                list: [],
                mode: 0,
                $Chart: null,
                objectChart: null,
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                contador: 0,
                chartIn: 0,
                respuesta:true,
                total: 0,
                datosParaGrafica: []
            }
        },
        computed: {
            ...mapState(["permiso"]),

            todosAbiertos() {
                return this.list.length > 0 && this.list.every(n => n.isOpen);
            },

            hayNegociosEnTarta() {
                return this.list.some(negocio => negocio.enTarta);

                
            },

            urlExportPDF() {
                return this.$store.getters.apiUrl+"/products/exportVentasTotalProduct/PDF?datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt


            },
            urlExportExcel() {
                //  return "../api/public/index.php/suppliers/exportGastosSupplier/Excel?idBusiness=" + this.idBusiness + "&procedencia=" + this.procedencia + "&idSupplier=" + this.idSupplier + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt

                return this.$store.getters.apiUrl+"/products/exportVentasTotalProduct/Excel?datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt


            },

            urlExportPDFGlobal() {
            return this.$store.getters.apiUrl + "products/exportVentasTotalProduct/PDF?datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&agrupar=true&jwt=" + this.$store.getters.jwt;
            },

            urlExportExcelGlobal() {
                return this.$store.getters.apiUrl + "products/exportVentasTotalProduct/Excel?datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&agrupar=true&jwt=" + this.$store.getters.jwt;
            },
            
            listaGlobalAplanada() {
                let lista = [];
                
                this.list.forEach(negocio => {
                    negocio.products.forEach(prod => {
                        let existe = lista.find(p => p.name === prod.name);
                        if (existe) {
                            existe.cantidad += parseFloat(prod.cantidad);
                            existe.importe += parseFloat(prod.importe);
                        } else {
                            lista.push({
                                name: prod.name,
                                cantidad: parseFloat(prod.cantidad),
                                importe: parseFloat(prod.importe)
                            });
                        }
                    });
                });

                lista.sort((a, b) => {
                    let modifier = this.globalSortOrder === 'asc' ? 1 : -1;
                    
                    if (this.globalSortCol === 'name') {
                        return a.name.localeCompare(b.name) * modifier;
                    }
                    if (this.globalSortCol === 'cantidad') {
                        return (a.cantidad - b.cantidad) * modifier;
                    }
                    if (this.globalSortCol === 'importe' || this.globalSortCol === 'porcentaje') {
                        return (a.importe - b.importe) * modifier;
                    }
                    if (this.globalSortCol === 'precioMedio') {
                        let precioA = a.cantidad > 0 ? a.importe / a.cantidad : 0;
                        let precioB = b.cantidad > 0 ? b.importe / b.cantidad : 0;
                        return (precioA - precioB) * modifier;
                    }
                });

                return lista;
            },

            totalGlobalImporte() {
                return this.listaGlobalAplanada.reduce((acc, p) => acc + parseFloat(p.importe), 0);
            },
            

            /* getTotalPrecio() {
                let total = 0;
                this.total = 0;
                this.list.forEach(function (d) {

                    total += d.importe;

                });

                this.total = total;

                return total;
            } */
        },
        methods: {
            async toggleNegocio(index) {
                let negocio = this.list[index];
                
                negocio.isOpen = !negocio.isOpen;
                negocio.enTarta = negocio.isOpen;

                if (negocio.isOpen && !negocio.isLoaded) {
                    negocio.isLoading = true; 
                    try {
                        var config = {
                            params: {
                                idBusiness: negocio.idBusiness,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };
                        
                        let resp = await this.axios.get(this.$store.getters.apiUrl + "products/getProductsByBusiness", config);

                        if (resp.data.response === true) {
                            negocio.products = resp.data.result || [];
                            negocio.isLoaded = true; 
                        } else {
                            swal({ title: "Atención", text: resp.data.message || "Sin permisos", type: "warning" });
                            negocio.isOpen = false;
                            negocio.enTarta = false;
                        }
                    } catch (error) {
                        swal({ title: "Error", text: "Fallo de conexión.", type: "error" });
                        negocio.isOpen = false;
                        negocio.enTarta = false;
                    } finally {
                        negocio.isLoading = false;
                        this.recalcularTarta();
                    }
                } else {
                    this.recalcularTarta();
                }
            },

            async toggleTodos() {
                if (this.todosAbiertos) {
                    // Si están todos abiertos, los cerramos de golpe
                    this.list.forEach(n => {
                        n.isOpen = false;
                        n.enTarta = false;
                    });
                    this.recalcularTarta();
                } else {
                    // Comprobamos si hay algún local que aún NO se haya descargado
                    let faltanPorCargar = this.list.some(n => !n.isLoaded);

                    if (!faltanPorCargar) {
                        // Si ya los tenemos todos en memoria, los abrimos al instante y terminamos
                        this.list.forEach(n => {
                            n.isOpen = true;
                            n.enTarta = true;
                        });
                        this.recalcularTarta();
                        return; // Cortamos la ejecución aquí. Cero peticiones al servidor.
                    }

                    // Si la ejecución llega hasta aquí, es que faltan datos. Hacemos la petición:
                    this.cargandoTodos = true;

                    // Usamos las fechas de la última consulta válida
                    let paramsDateFrom = this.$store.getters.dateFrom ? this.$store.getters.dateFrom : this.datefrom;
                    let paramsDateTo = this.$store.getters.dateTo ? this.$store.getters.dateTo : this.dateto;

                    let config = {
                        params: {
                            datefrom: moment(paramsDateFrom).startOf("day").unix(),
                            dateto: moment(paramsDateTo).endOf("day").unix(),
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    try {
                        let resp = await this.axios.get(this.$store.getters.apiUrl + "products/getSalesTotalProducts", config);

                        if (resp.data.response === true) {
                            let negociosCompletos = resp.data.result;

                            this.list.forEach(negocio => {
                                let negocioDescargado = negociosCompletos.find(b => b.idBusiness === negocio.idBusiness);
                                
                                if (negocioDescargado && negocioDescargado.products) {
                                    negocio.products = negocioDescargado.products;
                                    negocio.isLoaded = true; // Marcamos como cargado
                                } else {
                                    negocio.products = [];
                                    negocio.isLoaded = true;
                                }
                                
                                negocio.isOpen = true;
                                negocio.enTarta = true;
                            });

                            this.recalcularTarta();
                            
                        } else if (resp.data.response == false && resp.data.rangoMayor == true) {
                            this.noAgrupar = false;
                            swal({
                                title: "Lo sentimos",
                                text: resp.data.result,
                                confirmButtonClass: "btn btn-info btn-fill",
                                type: "info",
                            });
                            
                        } else {
                            this.noAgrupar = false;
                            swal({
                                title: this.$t('accesoDenegado') || 'Error',
                                text: resp.data.message || 'Error al obtener los datos',
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    } catch (error) {
                        console.error("Error al descargar todos los negocios de golpe:", error);
                        this.noAgrupar = false;
                    } finally {
                        this.cargandoTodos = false;
                    }
                }
            },

            async handleCambioAgrupacion() {
                // Si el usuario activa "Ver lista global"
                if (this.noAgrupar && this.list.length > 0) {
                    // Verificamos si no están todos los locales ya metidos en la tarta
                    if (!this.todosAbiertos) {
                        // Si falta alguno, llamamos a la función
                        await this.toggleTodos(); 
                    }
                }
                
                this.recalcularTarta();
            },
            
            recalcularTarta() {
                let productosActivos = this.list
                    .filter(n => n.enTarta)
                    .flatMap(n => n.products);

                let totalAgrupado = productosActivos.reduce((acc, producto) => {
                    if (!acc[producto.name]) {
                        acc[producto.name] = { name: producto.name, cantidad: 0, importe: 0 };
                    }
                    acc[producto.name].cantidad += parseFloat(producto.cantidad);
                    acc[producto.name].importe += parseFloat(producto.importe);
                    return acc;
                }, {});

                this.datosParaGrafica = Object.values(totalAgrupado);

                this.$nextTick(() => {
                    if(this.hayNegociosEnTarta) {
                        this.initChart(); 
                    } else if (this.objectChart !== null) {
                        this.objectChart.destroy();
                        this.objectChart = null;
                        this.contador = 0;
                    }
                });
            },

            sortGlobal(col) {
                if (this.globalSortCol === col) {
                    this.globalSortOrder = this.globalSortOrder === 'asc' ? 'desc' : 'asc';
                } else {
                    this.globalSortCol = col;
                    this.globalSortOrder = 'desc'; 
                }
            },
            getGlobalSortIcon(col) {
                if (this.globalSortCol !== col) return 'fa-sort text-muted';
                return this.globalSortOrder === 'asc' ? 'fa-angle-up' : 'fa-angle-down';
            },

            sortLocal(col) {
                if (this.localSortCol === col) {
                    this.localSortOrder = this.localSortOrder === 'asc' ? 'desc' : 'asc';
                } else {
                    this.localSortCol = col;
                    this.localSortOrder = 'desc';
                }

                this.list.forEach(negocio => {
                    negocio.products.sort((a, b) => {
                        let modifier = this.localSortOrder === 'asc' ? 1 : -1;
                        
                        if (col === 'name') {
                            return a.name.localeCompare(b.name) * modifier;
                        }
                        if (col === 'cantidad') {
                            return (parseFloat(a.cantidad) - parseFloat(b.cantidad)) * modifier;
                        }
                        if (col === 'importe' || col === 'porcentaje') {
                            return (parseFloat(a.importe) - parseFloat(b.importe)) * modifier;
                        }
                        if (col === 'precioMedio') {
                            let precioA = parseFloat(a.cantidad) > 0 ? parseFloat(a.importe) / parseFloat(a.cantidad) : 0;
                            let precioB = parseFloat(b.cantidad) > 0 ? parseFloat(b.importe) / parseFloat(b.cantidad) : 0;
                            return (precioA - precioB) * modifier;
                        }
                    });
                });
            },
            
            getLocalSortIcon(col) {
                if (this.localSortCol !== col) return 'fa-sort text-muted';
                return this.localSortOrder === 'asc' ? 'fa-angle-up' : 'fa-angle-down';
            },
            
            getPorcentajeGlobal(importeLocal) {
                if (!this.totalGlobalImporte || this.totalGlobalImporte === 0) return "0.00";
                return ((importeLocal * 100) / this.totalGlobalImporte).toFixed(2);
            },
            getTotalPorNegocio(productos) {
                let total = 0;
                productos.forEach(function (p) {
                    total += p.importe;
                });
                return total;
            },
            getPorcentajeLocal(importe, productos) {
                let total = this.getTotalPorNegocio(productos);
                if (total === 0) return "0.00";
                return ((importe / total) * 100).toFixed(2);
            },

            getSalesProducts() {
                this.noAgrupar = false;

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        this.loading = true;
                        this.searchPerformed = true;
                        this.statusConsulta = 'loading';

                        var config = {
                            params: {
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.axios.get(this.$store.getters.apiUrl + "products/getSummaryBusinessesWithSales", config)
                            .then(function (response) {

                                if (response.data.response) {
                                    // console.log("Datos recibidos de PHP:", response.data);

                                    // Guardamos las fechas válidas en memoria
                                    vm.$store.dispatch("setDateTo", vm.dateto);
                                    vm.$store.dispatch("setDateFrom", vm.datefrom);

                                    let resultadosLimpios = response.data.result || [];
                                    vm.list = resultadosLimpios.map(negocio => ({
                                        ...negocio,
                                        isOpen: false,
                                        enTarta: false,
                                        isLoaded: false,
                                        isLoading: false,
                                        products: []        
                                    }));
                                    
                                    vm.statusConsulta = 'success';
                                    vm.respuesta = true;

                                    vm.$nextTick(() => {
                                        vm.recalcularTarta();
                                    });
                                    
                                } else if (response.data.response == false && response.data.rangoMayor == true) {
                                    swal({
                                        title: "Lo sentimos",
                                        text: response.data.result,
                                        confirmButtonClass: "btn btn-info btn-fill",
                                        type: "info",
                                        title: "Lo sentimos",
                                        text: response.data.result,
                                        confirmButtonClass: "btn btn-info btn-fill",
                                        type: "info",
                                    });
                                    
                                    vm.statusConsulta = 'success';
                                    
                                    if (vm.list.length === 0) {
                                        vm.searchPerformed = false;
                                    }
                                    
                                } else {
                                    swal({
                                        title: vm.$t('accesoDenegado'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });
                                    
                                    vm.statusConsulta = 'success';

                                    if (vm.list.length === 0) {
                                        vm.searchPerformed = false;
                                    }
                                }
                                vm.loading = false;

                            })
                            .catch(function (error) {
                                vm.statusConsulta = 'success'; 
                                vm.loading = false;
                                
                                if (vm.list.length === 0) {
                                    vm.searchPerformed = false;
                                }
                                
                                console.error(error);
                            });
                    }
                }
            },


            initChart() {
                // Cogemos los datos que ya ha sumado recalcularTarta()
                let productosGlobales = [...this.datosParaGrafica];

                if (this.chartIn === 0) {
                    productosGlobales.sort((a, b) => b.cantidad - a.cantidad);
                } else {
                    productosGlobales.sort((a, b) => b.importe - a.importe);
                }

                var labels = productosGlobales.map(function(x) { return x.name; });
                var data = productosGlobales.map(x => this.chartIn === 0 ? x.cantidad : x.importe);

                var randomColor = require("randomcolor");
                var colors = randomColor({
                    luminosity: "dark",
                    count: labels.length,
                    format: "rgb",
                });

                let backgroundColors = colors.map(function(x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                });

                let borderColors = colors.map(function(x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)";
                });

                let hoverBackgroundColors = colors.map(function(x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)";
                });

                if (this.contador == 0) {
                    if (this.list.length > 0) {
                        this.objectChart = new Chart("chart", {
                            type: "pie",
                            data: {
                                labels: labels,
                                datasets: [{
                                    data: data,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    hoverBackgroundColor: hoverBackgroundColors,
                                    borderWidth: 1,
                                }],
                            },
                            options: {
                                legend: {
                                    display: false,
                                    position: "bottom",
                                },
                                maintainAspectRatio: false,
                            },
                        });
                        this.contador++;
                    }
                } else {
                    this.objectChart.destroy();
                    this.objectChart = new Chart("chart", {
                        type: "pie",
                        data: {
                            labels: labels,
                            datasets: [{
                                data: data,
                                backgroundColor: backgroundColors,
                                borderColor: borderColors,
                                hoverBackgroundColor: hoverBackgroundColors,
                                borderWidth: 1,
                            }],
                        },
                        options: {
                            legend: {
                                display: false,
                                position: "bottom",
                            },
                            maintainAspectRatio: false,
                        },
                    });
                }
            }
        }
    }
</script>

<style scoped>


    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

    .status-bar {
        height: 5px;
        width: 100%;
        border-radius: 3px;
        transition: background-color 0.4s ease;
        margin-bottom: 20px;
    }
    .idle { background-color: #3498db; }
    .loading { background-color: #f1c40f; }
    .error { background-color: #e74c3c; }
    .success { background-color: #2ecc71; }

    .card-header:hover {
        background-color: #e9ecef !important;
        transition: background-color 0.2s ease;
    }

    .desglose-wrapper {
        display: grid;
        grid-template-rows: 0fr;
        transition: grid-template-rows 0.5s ease-in-out; 
    }
    
    .desglose-wrapper.is-open {
        grid-template-rows: 1fr;
    }
    
    .desglose-inner {
        overflow: hidden;
        min-height: 0;
        opacity: 0;
        transition: opacity 0.5s ease-in-out; 
    }

    .desglose-wrapper.is-open .desglose-inner {
        opacity: 1;
        transition: opacity 0.5s ease-in-out; 
    }

    /* AJUSTES MÓVIL */
    @media (max-width: 767px) {
        .btn-block-mobile {
            width: 100% !important;
        }
        .card {
            padding: 15px 10px !important;
        }
        .div-export {
            background: #f8f9fa;
            padding: 15px;
            border-radius: 8px;
        }
        .breadcrumb {
            font-size: 12px;
        }
        h4 {
            font-size: 1.25rem !important;
    }

}
    @media (min-width: 768px) {
        .btn-block-mobile {
            width: 150px !important;
        }
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Productos/VentasTotalProducto.vue